import { ReactNode } from 'react'
import { Box } from '@mui/material'
import getBackgroundImageSize from '../../../utils/images/getBackgroundImageSize'

export type CardImageProps = {
    imageSrc?: string
    largeImage?: boolean
    contrastCard?: boolean
    backgroundColor?: string
    children: ReactNode
}

export default function CardImage({
    imageSrc,
    largeImage,
    backgroundColor,
    contrastCard,
    children
}: CardImageProps) {
    // BUG: getBackgroundImageSize is a hook; it should be called inside a conditional statement.
    const backgroundImageSize = getBackgroundImageSize({
        imageSrc: imageSrc ?? '',
        largeImage
    })
    const backgroundSize = imageSrc ? backgroundImageSize : 'cover'

    return (
        <Box
            sx={{
                height: largeImage ? 400 : contrastCard ? 130 : 200,
                background: imageSrc
                    ? `url(${imageSrc}) no-repeat center, ${
                          backgroundColor || 'none'
                      } `
                    : 'none',
                backgroundSize: contrastCard ? 130 : backgroundSize,
                backgroundPosition: 'center center',
                borderTopLeftRadius: 2,
                borderTopRightRadius: 2,
                transition: 'background-size 0.3s ease'
            }}
        >
            {children}
        </Box>
    )
}
